var map = {
	"./aparthotelclub/ic_tag_price_gray.png": 64039,
	"./beachful/ic_tag_price_gray.png": 25982,
	"./castlepedia/ic_tag_price_gray.png": 74281,
	"./cocktayl/ic_tag_price_gray.png": 84960,
	"./ic_tag_price_gray.png": 24471,
	"./luxresortclub/ic_tag_price_gray.png": 81120,
	"./parkful/ic_tag_price_gray.png": 35815,
	"./prefabworld/ic_tag_price_gray.png": 68164,
	"./rooftopclub/ic_tag_price_gray.png": 44656,
	"./spaclub/ic_tag_price_gray.png": 91738,
	"./worldcasino/ic_tag_price_gray.png": 62635,
	"./zoopedia/ic_tag_price_gray.png": 68113
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85204;